export class EmailVerificationParams {
  accountId: string;
  token: string;

  constructor(accountId: string, token: string) {
    this.accountId = accountId;
    this.token = token;
  }
}

export class ResendVerificationParams {
  accountId: string;

  constructor(accountId: string) {
    this.accountId = accountId;
  }
}
